if (!global._babelPolyfill) {
    require('babel-polyfill')
};

let browserHistory = require("react-router").browserHistory;
import React from "react";
import { connect } from "react-redux";

import * as actionTypes from "../actions/actionTypes";
let actions = require("../actions/actions");

export class ReviewUploadConfirmationModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.result.actionType === actionTypes.REVIEW_UPLOAD_SUCCESS) {
            browserHistory.push("/fort/modparty/under-review/");
            this.props.dismissModal();
        }
    }

    componentWillMount() {
        this.props.reviewUpload(this.props.upload.id);
    }

    render() {
        return (
            <div
                className={
                    "react-modal full-transparent moderation-modal-background"
                }
            >
                <a
                    href="#"
                    className="modal-background-closer"
                    onClick={this.props.dismissModal}
                />
                <div className={"inner-modal"}>
                    <div className="modal-content">
                        <h3 className="modal-title">Loading Upload...</h3>
                        <h4 className="modal-title gray">
                            Please wait as we prepare this upload for you.
                        </h4>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(null, {
    reviewUpload: actions.reviewUpload
})(ReviewUploadConfirmationModal);
